// This is a magic string replaced by rollup

const SDK_VERSION = "10.48.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
